import { groupValidators } from '@/Framework/UI/Organisms/FinalForm/validators/helpers';
import { validateEmail } from '@/Framework/UI/Organisms/FinalForm/validators/user/validateEmail';
import { validateRequiredField } from '@/Framework/UI/Organisms/FinalForm/validators/validateRequiredField';
import { validateRecaptchaVerified } from '@/Framework/UI/Organisms/FinalForm/validators/validateRecaptchaVerified';

const email = { fieldName: 'email', fieldCaption: 'Email' };
const feedback = { fieldName: 'feedback', fieldCaption: 'Notes', isPlural: true };

interface IProps {
  email: string,
  feedback: string,
  recaptcha: string,
}

export default (values:IProps) => groupValidators(
  validateEmail({ ...email, value: values.email }),
  validateRequiredField({ ...feedback, value: values.feedback }),
  validateRecaptchaVerified({ fieldName: 'recaptcha', value: values.recaptcha })
);
